let baseURL = 'https://api-pre.chinabeego.com/';
let env = window.localStorage.getItem('env') || 'pre';
baseURL = env == 'test' && 'https://api-test.chinabeego.com/' ||  baseURL;
baseURL = env == 'pre' && 'https://api-pre.chinabeego.com/' ||  baseURL;
baseURL = env == 'idc' && 'https://api.chinabeego.com/' ||  baseURL;

let basewsURL = 'wss://api-test.chinabeego.com/'
basewsURL = env == 'test' && 'wss://api-test.chinabeego.com/' ||  basewsURL;
basewsURL = env == 'testb' && 'wss://api-testb.chinabeego.com/' ||  basewsURL;
basewsURL = env == 'testc' && 'wss://api-testc.chinabeego.com/' ||  basewsURL;
basewsURL = env == 'testd' && 'wss://api-testd.chinabeego.com/' ||  basewsURL;
basewsURL = env == 'teste' && 'wss://api-teste.chinabeego.com/' ||  basewsURL;
basewsURL = env == 'pre' && 'wss://api-pre.chinabeego.com/' ||  basewsURL;
basewsURL = env == 'prec' && 'wss://api-prec.chinabeego.com/' ||  basewsURL;
basewsURL = env == 'idc' && 'wss://api.chinabeego.com/' ||  basewsURL;
if (process.env.NODE_ENV == 'production') {
  basewsURL = process.env.VUE_APP_BASEWSURL
}


export default {
  envName: env,
  baseURL,
  basewsURL
}